import { Form, FormInstance } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/store';
import { uiModel } from 'entities/ui';
import { SubstitutionsTypes } from 'shared/enums';
import { useCreateSubstitutionMutation } from 'app/services/edpApiV1/substitutions/substitution';
import { useNotifications } from 'shared/hooks/use-notifications';
import { useEffect } from 'react';
import { DatePeriodField } from 'shared/ui/form/DatePeriodField';
import { viewerModel } from 'entities/viewer';
import { getErrorData } from 'shared/helpers/utils';
import { convertDate } from 'shared/helpers/date';
import { SERVER_DATE_MASK } from 'shared/constants';
import { SubstitutionFormData } from '../../types';
import { SearchEmployeesField } from '../search-employees-field';
import style from '../index.module.scss';
import { EmployeeVocations } from '../employee-vocations';

interface IProps {
  form: FormInstance<SubstitutionFormData>;
}

export const CreateSubstitution: React.FC<IProps> = ({ form }) => {
  const dispatch = useAppDispatch();

  const { name, middleName, lastName, position } = useAppSelector(viewerModel.me.selectors.getViewerProfileInfo);
  const { controlDrawer } = useAppSelector(uiModel.Substitutions.selectors.selectSubstitutions);

  const [
    createSubstitutionTrigger,
    { isSuccess: createIsSucces, isError: createIsError, reset: createReset, error: createError },
  ] = useCreateSubstitutionMutation({
    selectFromResult: result => ({ ...result, error: getErrorData(result.error) }),
  });

  const onFinish = (data: SubstitutionFormData) => {
    const { employeeId, period } = data;
    if (controlDrawer?.substitution.id) {
      createSubstitutionTrigger({
        type: controlDrawer?.substitution.type,
        divisionId: controlDrawer?.substitution.id,
        employeeId,
        validFrom: convertDate(period[0], { format: SERVER_DATE_MASK }),
        validTo: convertDate(period[1], { format: SERVER_DATE_MASK }),
      });
    }
  };

  useNotifications(
    createIsSucces,
    createIsError,
    controlDrawer?.substitution.type === SubstitutionsTypes.acting ? 'И.О. назначен' : 'Замещающий назначен',
    createError?.message,
    createReset,
  );

  useEffect(() => {
    if (createIsSucces) {
      dispatch(uiModel.Substitutions.actions.closeSubstitutionControlDrawer());
    }
  }, [createIsSucces]);

  return (
    <>
      <div className={style.author}>
        <h4>Автор замещения:</h4>
        <div>{`${lastName} ${name ? name[0] : ''}. ${middleName ? middleName[0] : ''}.`}</div>
        <div className={style.position}>{position || ''}</div>
      </div>

      <Form layout="vertical" form={form} onFinish={onFinish}>
        <SearchEmployeesField
          divisionId={controlDrawer?.substitution.id}
          searchDivisionId={
            controlDrawer?.substitution.type === SubstitutionsTypes.deputy ? controlDrawer?.substitution.id : undefined
          }
        />
        <EmployeeVocations />
        <DatePeriodField />
      </Form>
    </>
  );
};
